import root from 'window-or-global';
import {presenceTypes} from '../../constants';
import {Friend, SocialBridge, SocialResponseCallback} from '../socialBridge';
import PresenceType from '../../constants/PresenceType';
import {createClassLogger, Logger} from '../../utils/Logging';

const logger: Logger = createClassLogger('SocialBridge:Mock');

let _onlineStatus: PresenceType = presenceTypes.ONLINE;

const socialMock: SocialBridge = {
    getFriendsList: async (): Promise<Friend[]> => {
        logger.info('getFriendsList', 'MOCKED, with simulated response');
        return [
            {
                appid: 'fortnite',
                displayname: 'Dave',
                facebookname: '',
                friendid: '4dec2a85fd78491b9a62e1442874af70',
                hasvoicesupport: false,
                isjoinable: false,
                isonline: true,
                isplaying: true,
                onlinestatus: 'Online',
                platform: '',
                playstationname: '',
                presence: PresenceType.ONLINE
            },
            {
                appid: '',
                displayname: 'Mark',
                facebookname: 'Marky Foo',
                friendid: 'a3de76e39cba4d0ea52bdadd6192a24b',
                hasvoicesupport: false,
                isjoinable: false,
                isonline: true,
                isplaying: false,
                onlinestatus: 'Away',
                platform: '',
                playstationname: '',
                presence: PresenceType.ONLINE
            },
            {
                appid: '',
                displayname: 'Mindy',
                facebookname: '',
                friendid: '79576b93403549bb84d1cf18d85b3d5e',
                hasvoicesupport: false,
                isjoinable: false,
                isonline: false,
                isplaying: false,
                onlinestatus: 'Offline',
                platform: '',
                playstationname: '',
                presence: PresenceType.AWAY
            },
            {
                appid: '',
                displayname: 'Susan',
                facebookname: '',
                friendid: 'a64e51d7f9b149e7a2ca064d0a56d3b2',
                hasvoicesupport: false,
                isjoinable: false,
                isonline: false,
                isplaying: false,
                onlinestatus: 'Offline',
                platform: '',
                playstationname: '',
                presence: PresenceType.OFFLINE
            }
        ];
    },

    getOnlineStatus: async (): Promise<PresenceType> => _onlineStatus,

    setStatusOnline: async (): Promise<void> => {
        logger.info('setStatusOnline', 'MOCKED, with simulated response');
        _onlineStatus = presenceTypes.ONLINE;
    },

    setStatusAway: async (): Promise<void> => {
        logger.info('setStatusAway', 'MOCKED, with simulated response');
        _onlineStatus = presenceTypes.AWAY;
    },

    openChat: async (): Promise<void> => {
        logger.info('openChat', 'MOCKED');
    },

    hasThirdPartyAccounts: async (thirdParty: string): Promise<boolean> => {
        logger.info('hasThirdPartyAccounts', 'MOCKED, with simulated response', {thirdParty});
        if (thirdParty === 'steam') {
            return true;
        }
        return false;
    },

    registerResponseCallback: async (callback: SocialResponseCallback): Promise<void> => {
        logger.info(
            'registerResponseCallback',
            'MOCKED, use __socialResponseCallback to trigger callback'
        );
        root.__socialResponseCallback = callback;
    }
};

export default socialMock;
